import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate, useLocation, NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Button, Form, FormGroup, Input } from "reactstrap";
import useMetaMask from "hooks/metsmask";
import NotifyDropdown from "./Notification";
import * as wallet from "utils/walletconnect";
import toastr from "toastr";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  logoutUser,
  putProfile,
  getCollections,
  getCurrentUser,
  getSearch,
  cateGories,
  getCategories,
  rquestForVerfication,
  getArtNotificationsRequest,
  polygonAuthUpdate,
} from "store/actions";
import axios from "axios";

export default function Header() {
  const getWalletAddress = localStorage.getItem("walletAddress");
  const hooks = useMetaMask();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const searchRef = useRef();

  const [nav, setNav] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [state, setstate] = useState(null);
  const [isSearch, setSearch] = useState(false);
  const [searchItem, setSearchItem] = useState([]);
  const [searchCollection, setSearchCollection] = useState([]);
  const [isUser, setIsUser] = useState([]);

  const [searchArt, setsearchArt] = useState([]);

  const { authToken, user, settings } = useSelector((state) => state?.Login);
  const { newCategory } = useSelector((state) => state?.categories);

  const logOut = async(e) => {
    localStorage.clear();
    toastr.success("Logged out Successfully");
    dispatch(logoutUser(location));
    setNav(!nav)
    
    if (user?._id) {
      const authData = await axios.get(`${process.env.REACT_APP_JS_VERIFIER_URL}logout`, {
        params: {
          user_id: user?._id,
        },
      });
      const callback = (res) => {
      }
      dispatch(polygonAuthUpdate(user?._id, callback))
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
  }, []);

  useEffect(() => {
    dispatch(cateGories());
  }, []);

  useEffect(() => {
    setstate(hooks);
  }, [hooks]);

  useEffect(() => {
    if (state?.isActive && state?.account && !authToken) {
      dispatch(
        putProfile({ walletAddress: state?.account }, navigate("/login"))
      );
      getCollections();
    }
    // if (state?.account) {
    //   localStorage.setItem("walletAddress", state?.account);
    // }
  }, [state?.isActive, state?.account]);

  useEffect(() => {
    dispatch(getCategories());
  }, []);

  useEffect(() => {
    if (user?._id) {
      let data = {}
      data.receiver = user?._id
      const artNotificationApiCallback = (res) => {
        // if()

      }
      dispatch(getArtNotificationsRequest(data, artNotificationApiCallback))
    }
  }, [user?._id])

  const callback = (data) => {
    if (

      data.item != [] ||
      data.collection != [] ||
      data?.user != [] ||
      data?.category != []
    ) {
      if (data?.item != []) {
        setSearchItem(data.item);
      }

      if (data?.collection != []) {
        setSearchCollection(data?.collection);
      }

      if (data.user != []) {
        setIsUser(data?.user);
      }

      if (data.category != []) {
        setsearchArt(data?.category);
      }

      setSearch(true);
    } else {
      setSearch(false);
    }
  };

  const toggleSearch = (e) => {
    e.preventDefault();
    if (e.target.value != "") {
      dispatch(getSearch(e.target.value, callback));
    } else {
      setSearch(false);
    }
  };

  const getVerification = () => {
    dispatch(rquestForVerfication(() => dispatch(getCurrentUser())));
    toastr.success("Success");
  };

  useEffect(() => {
    if (user?._id) {
      dispatch(
        getCollections({
          limit: 10,
          orderBy: "",
          order: "",
          page: 1,
          author: user?._id,
        })
      );
    }
  }, [user?._id]);

  const copyToClipboard = (text) => {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed";
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
    } catch (ex) {
    } finally {
      document.body.removeChild(textarea);
    }
    toastr.success("Copied to clipboard!");
  };

  const CreateItem = () => {
    if (!getWalletAddress) {
      toastr.error("Please Connect your MetaMask Account");
    } else {
      navigate("/create");
    }
  };

  const getProfile = (_id) => {
    navigate(`/view-profile/${_id}`);
  };
  return (
    <section className={scroll ? "header-main  fixed-header" : "header-main"}>
      <Container fluid="xxl">
        <Row>
          <Col lg={12}>
            <div className="header">
              <nav className="navbar navbar-expand-lg w-100 py-0">
                <div className="container-fluid px-0">
                  <div className="d-flex align-items-center w-100">
                    <div className="loginInner">
                      <div className="logobx">
                        {/* <button className="btn border-0"><i className="fa-sharp fa-light fa-arrow-left-long"></i> Back</button> */}
                        <a href="https://terpnash.com/" rel="noreferrer" className="navbar-brand py-0">
                          {settings?.logo?.link && (
                            <div className="d-flex align-items-center justify-content-start position-relative gap-3">
                              <>
                                {settings?.logo?.link.search(".mp4") !== -1 ? (
                                  <img
                                    src={settings?.logo?.link || "/images/t3.gif"}
                                    // src={"/images/t3.gif"}
                                    alt="logo"
                                  />
                                ) : (
                                  <img
                                    alt="logo"
                                    className="img-fluid logodesktop"
                                    src={settings?.logo?.link || "/images/t3.gif"}
                                  // src={"/images/t3.gif"}
                                  />
                                )}
                              </>

                              {/* <a href="https://terpnash.com/" rel="noreferrer"

                                className="nav-link loginLogo logohead "
                              >
                                Terpnash
                              </a> */}
                            </div>
                          )}
                        </a>
                      </div>
                    </div>

                    <div className="Newnavbar ms-auto">
                      <ul className="menuMaine">
                        <li>
                          <ul className="navbar-nav newTopHeader scroll-menu ms-auto mb-2 me-3 mb-lg-0">
                            {/* <li className="nav-item">
                            <NavLink
                              to="/museums"
                              activeclassname="active"
                              className={"nav-link"}
                            >
                              Museums
                            </NavLink>
                          </li> */}
                            <li className="nav-item">
                              <NavLink
                                to="/art-genres"
                                state={"artgenre"}
                                activeclassname="active"
                                className={"nav-link"}
                              >
                                Art Genres
                              </NavLink>
                            </li>
 <li className="nav-item">
                <NavLink
                  to="/custom-art"
                  // state={"artgenre"}
                  activeclassname="active"
                  className={"nav-link"}
                >
                  Custom Art
                </NavLink>
              </li>
                            <li className="nav-item">
                              <NavLink
                                to="/community"
                                activeclassname="active"
                                className={"nav-link"}
                              >
                                Community
                              </NavLink>
                            </li>

                            <li className="nav-item with90">
                              <a
                                className="nav-link gradient-text"
                                href="https://shop.thestitchnprintstore.com/terpnash/shop/home"
                                target="_blank"
                                rel="noreferrer"
                              >
                                Merch
                              </a>
                            </li>

                            <li className="nav-item with80 desktop-li">
                              <p
                                // className="nav-link gradient-text"
                                aria-current="page"
                                className="nav-link dropdown-toggle cursor-pointer"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                FAQs
                              </p>

                              <ul className="submenu dropdown-menu">
                                <li>
                                  <Link
                                    to="/user-faq"
                                    className="nav-link"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    Users
                                  </Link>
                                </li>

                                <li>
                                  <Link
                                    to="/artist-faq"
                                    className="nav-link"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    Artists
                                  </Link>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <div className="searchBoxNew me-3">
                            <Form>
                              <FormGroup className="position-relative mb-0">
                                <button
                                  type="button"
                                  className="btn text-white position-absolute end-0 top-0 bottom-0 border-0 shadow-0"
                                >
                                  <i className="fa-light fa-magnifying-glass"></i>
                                </button>
                                <Input
                                  autoComplete="off"
                                  type="text"
                                  className="searcinp"
                                  name="search"
                                  placeholder="Search Artworks, Artist"
                                  // onKeyUp={toggleSearch}
                                  onChange={toggleSearch}
                                />
                              </FormGroup>
                            </Form>
                            {isSearch && (
                              <div className="searchResult" ref={searchRef}>
                                {searchItem?.length <= 0 &&
                                  searchCollection?.length <= 0 &&
                                  searchArt?.length <= 0 &&
                                  isUser?.length <= 0 ? (
                                  <h5 className="text-center">
                                    No result found!!
                                  </h5>
                                ) : (
                                  ""
                                )}

                                {searchItem?.length > 0 ? <h5>Artworks -- </h5> : ""}
                                <ul>
                                  {searchItem &&
                                    searchItem?.map((item, idx) => (
                                      <li key={idx}>
                                        <Link
                                          to={"/nftsale/" + item?.sellItem_id}
                                          onClick={() => setSearch(false)}
                                        >
                                          {item?.name}
                                        </Link>
                                      </li>
                                    ))}
                                </ul>

                                {searchCollection?.length > 0 ? (
                                  <h5>Collections -- </h5>
                                ) : (
                                  ""
                                )}
                                <ul>
                                  {searchCollection &&
                                    searchCollection?.map((col, idx) => (
                                      <li key={idx}>
                                        <Link
                                          to={`/card-profile?id=${col?.contractAddress}`}
                                        >
                                          {col?.name}
                                        </Link>
                                      </li>
                                    ))}
                                </ul>

                                {isUser?.length > 0 ? <h5>Users -- </h5> : ""}
                                <ul>
                                  {isUser &&
                                    isUser?.map((col, idx) => (
                                      <li key={idx}>
                                        <div
                                          onClick={() => getProfile(col?._id)}
                                          // onClick={() => getProfile(col)}
                                          className="search-coomom"
                                        >
                                          {col?.name}
                                        </div>
                                      </li>
                                    ))}
                                </ul>

                                {/* {searchArt?.length > 0 ? (
                                  <h5>Art Categories -- </h5>
                                ) : (
                                  ""
                                )} */}
                                {/* <ul>
                                  {searchArt &&
                                    searchArt?.map((col, idx) => (
                                      <li key={idx}>
                                        <Link to={`/shop?value=${col?._id}`}>
                                          {col?.name}
                                        </Link>
                                      </li>
                                    ))}
                                </ul> */}
                              </div>
                            )}
                          </div>
                        </li>
                        <li>
                          <div className="add-wallet-wrap ">
                            <div className="wallet-section">
                              {!authToken ? (
                                <>

                                  <Link
                                    to="/login"
                                    className="btn btn-primary  rounded-full text-white btn-sm loginbtn "
                                  >
                                    Login/Register
                                  </Link>
                                </>
                              ) : (
                                <>
                                  <NotifyDropdown />

                                  <UncontrolledDropdown>
                                    <DropdownToggle className="d-flex align-items-center gap-3">
                                      {user?.profileImage?.link ? (
                                        <img
                                          src={user?.profileImage?.link}
                                          alt=""
                                          className="img-fluid avatar"
                                        />
                                      ) : (
                                        <img
                                          src="/images/avatar.png"
                                          alt=""
                                          className="img-fluid avatar"
                                        />
                                      )}
                                      <i className="fa-light fa-chevron-down"></i>
                                    </DropdownToggle>

                                    <DropdownMenu>
                                      <DropdownItem className="btncopy">
                                        {(getWalletAddress && getWalletAddress != "undefined") ? (
                                          <>
                                            {!getWalletAddress ? null : (
                                              <p className="fontupdate"
                                                onClick={() =>
                                                  copyToClipboard(
                                                    getWalletAddress
                                                  )
                                                }
                                              >
                                                {getWalletAddress?.slice(
                                                  0,
                                                  10
                                                )}
                                                {"......."}
                                                {getWalletAddress?.slice(32)}
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="22"
                                                  height="22"
                                                  viewBox="0 0 22 22"
                                                  fill="none"
                                                >
                                                  <path
                                                    d="M17.875 1.375H6.35938C6.26484 1.375 6.1875 1.45234 6.1875 1.54688V2.75C6.1875 2.84453 6.26484 2.92188 6.35938 2.92188H17.0156V17.7031C17.0156 17.7977 17.093 17.875 17.1875 17.875H18.3906C18.4852 17.875 18.5625 17.7977 18.5625 17.7031V2.0625C18.5625 1.68223 18.2553 1.375 17.875 1.375ZM15.125 4.125H4.125C3.74473 4.125 3.4375 4.43223 3.4375 4.8125V16.2143C3.4375 16.3969 3.51055 16.5709 3.63945 16.6998L7.3627 20.423C7.40996 20.4703 7.46367 20.509 7.52168 20.5412V20.582H7.61191C7.68711 20.61 7.7666 20.625 7.84824 20.625H15.125C15.5053 20.625 15.8125 20.3178 15.8125 19.9375V4.8125C15.8125 4.43223 15.5053 4.125 15.125 4.125ZM8.20703 19.25H8.20273L4.98438 16.0316V16.0273H8.20703V19.25Z"
                                                    fill="black"
                                                  />
                                                </svg>
                                              </p>
                                            )}
                                          </>
                                        ) : (
                                          <Link to="/metamask-sign">
                                            <p className="metamsk fontupdate">
                                              <img
                                                className="p-0"
                                                src={
                                                  "/images/svg/MetaMask.svg"
                                                }
                                                alt="MetaMask"
                                              />{" "}
                                              Connect MetaMask
                                            </p>
                                          </Link>
                                        )}
                                      </DropdownItem>
                                      <DropdownItem>
                                        <Link
                                          to={`/profile/home`}
                                        // onClick={() => {
                                        //   window.location.href = `/profile?id=${user?._id}`;
                                        // }}
                                        >
                                          <img
                                            src={"/images/svg/myprofile.svg"}
                                            alt="My Profile"
                                          />
                                          My Profile
                                        </Link>
                                      </DropdownItem>
                                      {user?.verificationProfileStatus == "non" ||
                                        user?.verificationProfileStatus ==
                                        "requested" ? (
                                        <DropdownItem onClick={getVerification}>
                                          <div className="d-flex justify-content-start">
                                            <img
                                              src={
                                                "/images/svg/Verification.svg"
                                              }
                                              alt="Edit Profile"
                                            />

                                            {user?.verificationProfileStatus ==
                                              "requested" ? (
                                              <p className="verfication-para">
                                                Verification pending
                                              </p>
                                            ) : (
                                              <p className="verfication-para">
                                                Request for Verification
                                              </p>
                                            )}
                                          </div>
                                        </DropdownItem>
                                      ) : (
                                        ""
                                      )}

                                      {user?.verificationProfileStatus ==
                                        "reject" ? (
                                        <DropdownItem onClick={getVerification}>
                                          <div className="d-flex justify-content-start">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              x="0px"
                                              y="0px"
                                              width="20"
                                              height="20"
                                              viewBox="0 0 50 50"
                                            >
                                              <path d="M 31.236328 1.6972656 L 30.431641 2.109375 L 24.994141 4.8984375 L 18.75 1.7011719 L 14.943359 7.59375 L 7.9375 7.9472656 L 7.5878906 14.955078 L 1.6972656 18.763672 L 4.8984375 25.005859 L 1.7011719 31.25 L 7.59375 35.056641 L 7.9472656 42.0625 L 14.955078 42.412109 L 18.763672 48.302734 L 25.005859 45.101562 L 31.25 48.298828 L 35.056641 42.40625 L 42.0625 42.052734 L 42.412109 35.044922 L 48.302734 31.236328 L 45.101562 24.994141 L 48.298828 18.75 L 42.40625 14.943359 L 42.052734 7.9375 L 35.044922 7.5878906 L 31.236328 1.6972656 z M 30.539062 4.3027344 L 33.921875 9.5351562 L 40.146484 9.84375 L 40.460938 16.068359 L 45.693359 19.449219 L 42.855469 24.994141 L 45.697266 30.539062 L 40.464844 33.921875 L 40.15625 40.146484 L 33.931641 40.460938 L 30.550781 45.693359 L 25.005859 42.855469 L 19.460938 45.697266 L 16.078125 40.464844 L 9.8535156 40.15625 L 9.5390625 33.931641 L 4.3066406 30.550781 L 7.1445312 25.005859 L 4.3027344 19.460938 L 9.5351562 16.078125 L 9.84375 9.8535156 L 16.068359 9.5390625 L 19.449219 4.3066406 L 24.994141 7.1445312 L 30.539062 4.3027344 z M 32.474609 18.464844 L 22.273438 28.353516 L 17.541016 23.621094 L 15.419922 25.742188 L 22.240234 32.5625 L 34.5625 20.619141 L 32.474609 18.464844 z" />
                                            </svg>

                                            {user?.verificationProfileStatus ===
                                              "reject" ? (
                                              <p className="verfication-para">
                                                {" "}
                                                Request Again
                                              </p>
                                            ) : (
                                              <p className="verfication-para">
                                                Request for Verification
                                              </p>
                                            )}
                                          </div>
                                        </DropdownItem>
                                      ) : (
                                        ""
                                      )}

                                      <DropdownItem>
                                        <Link
                                          className="text-danger fw-bold"
                                          onClick={logOut}
                                          to="/"
                                        >
                                          <img
                                            src={"/images/svg/logout.svg"}
                                            alt="Logout"
                                          />
                                          Logout
                                        </Link>
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </>
                              )}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="ms-auto mobilembtn ">
                      {authToken && (<NotifyDropdown />)}
                      <button
                        className="btn menuopen border-0"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        onClick={() => setNav(!nav)}
                      >
                        <i className="fa-light fa-bars"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </Col>
        </Row>
      </Container>
      <div className={"mobileMenu " + (nav ? "active" : "")}>
        <div className="mMobile">
          <div>
            <div className="mProfile">
              {!authToken ? (
                <>
                  <Link
                    to="/login"
                    className="btn btn-primary text-white rounded-full btn-sm loginbtn"
                  >
                    Login/Register
                  </Link>
                </>
              ) : (
                <>
                  <div className="mProfileName text-decoration-none text-dark">
                    <Link to={`/profile/home`}>
                      <div className="mprofilePhoto">
                        {user?.profileImage?.link ? (
                          <img
                            src={user?.profileImage?.link}
                            alt=""
                            className="img-fluid avatar"
                          />
                        ) : (
                          <img
                            src="/images/avatar.png"
                            alt=""
                            className="img-fluid avatar"
                          />
                        )}
                      </div>
                    </Link>
                    <div className="mprofileNameBx">
                      <Link
                        className="text-decoration-none text-dark"
                        to={`/profile/home`}
                      >
                        <h1> {user?.name}</h1>
                      </Link>
                      {getWalletAddress ? (
                        <>
                          {!getWalletAddress ? null : (
                            <h2
                              onClick={() => copyToClipboard(getWalletAddress)}
                            >
                              {getWalletAddress?.slice(0, 5)}
                              {"......."}
                              {getWalletAddress?.slice(37)}
                              &nbsp;&nbsp;&nbsp; <i className="fa-light fa-copy"></i>
                            </h2>
                          )}
                        </>
                      ) : (
                        <Link to="/metamask-sign">
                          <h2 className="metamsk "> Connect MetaMask</h2>
                        </Link>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div onClick={() => setNav(!nav)} className="mCloseBtn">
                <i className="fa-sharp fa-light fa-xmark"></i>
              </div>
            </div>
            <div className="searchBoxNew my-3">
              <Form>
                <FormGroup className="position-relative mb-0">
                  <button
                    type="button"
                    className="btn text-white position-absolute end-0 top-0 bottom-0 border-0 shadow-0"
                  >
                    <i className="fa-light fa-magnifying-glass"></i>
                  </button>
                  <Input
                    autoComplete="off"
                    type="text"
                    className="searcinp px-3"
                    name="search"
                    placeholder="Search Items, Artist, Collections..."
                    // onKeyUp={toggleSearch}
                    onChange={toggleSearch}
                  />
                </FormGroup>
              </Form>
              {isSearch && (
                <div className="searchResult" ref={searchRef}>
                  {searchItem?.length <= 0 &&
                    searchCollection?.length <= 0 &&
                    searchArt?.length <= 0 &&
                    isUser?.length <= 0 ? (
                    <h5 className="text-center">
                      No result found!!
                    </h5>
                  ) : (
                    ""
                  )}

                  {searchItem?.length > 0 ? <h5>Items -- </h5> : ""}
                  <ul>
                    {searchItem &&
                      searchItem?.map((item, idx) => (
                        <li key={idx}>
                          <Link
                            to={"/nftsale/" + item?._id}
                            onClick={() => setSearch(false)}
                          >
                            {item?.name}
                          </Link>
                        </li>
                      ))}
                  </ul>

                  {searchCollection?.length > 0 ? (
                    <h5>Collections -- </h5>
                  ) : (
                    ""
                  )}
                  <ul>
                    {searchCollection &&
                      searchCollection?.map((col, idx) => (
                        <li key={idx}>
                          <Link
                            to={`/card-profile?id=${col?.contractAddress}`}
                          >
                            {col?.name}
                          </Link>
                        </li>
                      ))}
                  </ul>

                  {isUser?.length > 0 ? <h5>Artist -- </h5> : ""}
                  <ul>
                    {isUser &&
                      isUser?.map((col, idx) => (
                        <li key={idx}>
                          <div
                            onClick={() => getProfile(col?._id)}
                            className="search-coomom"
                          >
                            {col?.name}
                          </div>
                        </li>
                      ))}
                  </ul>

                  {searchArt?.length > 0 ? (
                    <h5>Art Categories -- </h5>
                  ) : (
                    ""
                  )}
                  <ul>
                    {searchArt &&
                      searchArt?.map((col, idx) => (
                        <li key={idx}>
                          <Link to={`/shop?value=${col?._id}`}>
                            {col?.name}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              )}
            </div>
            <ul className="navbar-nav newTopHeader scroll-menu ms-auto mb-2 me-3 mb-lg-0">
              {/* <li className="nav-item">
              <NavLink
                to="/museums"
                activeclassname="active"
                className={"nav-link"}
              >
                Museums
              </NavLink>
            </li> */}
              <li className="nav-item">
                <NavLink
                  to="/art-genres"
                  state={"artgenre"}
                  activeclassname="active"
                  className={"nav-link"}
                >
                  Art Genres
                </NavLink>
              </li>
 <li className="nav-item">
                <NavLink
                  to="/art-genres"
                  state={"artgenre"}
                  activeclassname="active"
                  className={"nav-link"}
                >
                  Custom Art
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/community"
                  activeclassname="active"
                  className={"nav-link"}
                >
                  Community
                </NavLink>
              </li>

              <li className="nav-item with90">
                <a
                  className="nav-link gradient-text"
                  href="https://shop.thestitchnprintstore.com/terpnash/shop/home"
                  target="_blank"
                  rel="noreferrer"
                >
                  Merch
                </a>
              </li>

              <li className="nav-item with80 desktop-li">
                <p
                  // className="nav-link gradient-text"
                  aria-current="page"
                  className="nav-link dropdown-toggle cursor-pointer"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  FAQ's
                </p>

                <ul className="submenu dropdown-menu">
                  <li>
                    <Link
                      to="/user-faq"
                      className="nav-link"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Users
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/artist-faq"
                      className="nav-link"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Artist
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          {authToken &&
            <ul className="mbottomMenu">
              <li>
                <Link
                  to={`/profile/home`}
                // onClick={() => {
                //   window.location.href = `/profile?id=${user?._id}`;
                // }}
                >
                  <img
                    src={"/images/svg/myprofile.svg"}
                    alt="My Profile"
                  />
                  My Profile
                </Link>
              </li>
              {user?.verificationProfileStatus == "non" ||
                user?.verificationProfileStatus ==
                "requested" ? (
                <li onClick={getVerification}>
                  <div className="d-flex justify-content-start">
                    <img
                      src={
                        "/images/svg/Verification.svg"
                      }
                      alt="Edit Profile"
                    />

                    {user?.verificationProfileStatus ==
                      "requested" ? (
                      <p className="verfication-para">
                        Verification pending
                      </p>
                    ) : (
                      <p className="verfication-para">
                        Request for Verification
                      </p>
                    )}
                  </div>
                </li>
              ) : (
                ""
              )}

              {user?.verificationProfileStatus ==
                "reject" ? (
                <li onClick={getVerification}>
                  <div className="d-flex justify-content-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="20"
                      height="20"
                      viewBox="0 0 50 50"
                    >
                      <path d="M 31.236328 1.6972656 L 30.431641 2.109375 L 24.994141 4.8984375 L 18.75 1.7011719 L 14.943359 7.59375 L 7.9375 7.9472656 L 7.5878906 14.955078 L 1.6972656 18.763672 L 4.8984375 25.005859 L 1.7011719 31.25 L 7.59375 35.056641 L 7.9472656 42.0625 L 14.955078 42.412109 L 18.763672 48.302734 L 25.005859 45.101562 L 31.25 48.298828 L 35.056641 42.40625 L 42.0625 42.052734 L 42.412109 35.044922 L 48.302734 31.236328 L 45.101562 24.994141 L 48.298828 18.75 L 42.40625 14.943359 L 42.052734 7.9375 L 35.044922 7.5878906 L 31.236328 1.6972656 z M 30.539062 4.3027344 L 33.921875 9.5351562 L 40.146484 9.84375 L 40.460938 16.068359 L 45.693359 19.449219 L 42.855469 24.994141 L 45.697266 30.539062 L 40.464844 33.921875 L 40.15625 40.146484 L 33.931641 40.460938 L 30.550781 45.693359 L 25.005859 42.855469 L 19.460938 45.697266 L 16.078125 40.464844 L 9.8535156 40.15625 L 9.5390625 33.931641 L 4.3066406 30.550781 L 7.1445312 25.005859 L 4.3027344 19.460938 L 9.5351562 16.078125 L 9.84375 9.8535156 L 16.068359 9.5390625 L 19.449219 4.3066406 L 24.994141 7.1445312 L 30.539062 4.3027344 z M 32.474609 18.464844 L 22.273438 28.353516 L 17.541016 23.621094 L 15.419922 25.742188 L 22.240234 32.5625 L 34.5625 20.619141 L 32.474609 18.464844 z" />
                    </svg>

                    {user?.verificationProfileStatus ===
                      "reject" ? (
                      <p className="verfication-para">
                        {" "}
                        Request Again
                      </p>
                    ) : (
                      <p className="verfication-para">
                        Request for Verification
                      </p>
                    )}
                  </div>
                </li>
              ) : (
                ""
              )}

              <li>
                <Link
                  className="text-danger fw-bold"
                  onClick={logOut}
                  to="/"
                >
                  <img
                    src={"/images/svg/logout.svg"}
                    alt="Logout"
                  />
                  Logout
                </Link>
              </li>
            </ul>
          }
        </div>
      </div>
    </section>
  );
}
